import types from "../index";
import subscriptions from "../../data/products";

export const defaultState = {
    step: 1,
    selectedSubscription: subscriptions.base,
    user: null,
    emailVerified: false,
    registrationError: null,
    amount: 0,
}

function registrationStepsReducer(state, action) {
    switch (action.type) {
        case types.REGISTRATION_STEPS_SET_STEP:
            return {
                ...state,
                step: action.step,
            }
        case types.REGISTRATION_STEPS_SELECT_SUBSCRIPTION:
            return {
                ...state,
                selectedSubscription: action.selectedSubscription
            }
        case types.REGISTRATION_STEPS_LOAD_USER:
            console.log(action.user);
            return {
                ...state,
                user: action.user,
            }
        case types.REGISTRATION_STEPS_SET_EMAIL_VERIFIED:
            return {
                ...state,
                emailVerified: action.status,
            }
        case types.REGISTRATION_STEPS_SET_REGISTRATION_ERROR:
            return {
                ...state,
                registrationError: action.message,
            }
        case types.REGISTRATION_STEPS_SET_AMOUNT:
            return {
                ...state,
                amount: action.amount,
            }
        default:
            throw new Error("Unhandled action type: " + action.type);
    }
}

export default registrationStepsReducer;
